export enum ImpairedDataSetSoringType {
  ByName,
  ByCategory,
  ByProvide
}

export type OrderingTypeValue = 'ASC' | 'DESC';

export type ImpairedDataSetSorting = {
  type: ImpairedDataSetSoringType;
  value: OrderingTypeValue;
};

export type ImpairedSorting = {
  type: string;
  value: OrderingTypeValue;
};
